import React from "react";

import ToolTip from "../ToolTip/ToolTip";
import type { MarginInterface } from "../utilities/interfaces";
import { getMargins } from "../utilities/margin";

interface InfoTooltipProps extends MarginInterface {
  text: string;
  direction?: "top" | "bottom" | "left" | "right";
  style?: React.CSSProperties;
}

const InfoTooltip = ({
  text,
  direction,
  style,
  m,
  mx,
  my,
  mt,
  mb,
  mr,
  ml,
}: InfoTooltipProps) => (
  <ToolTip
    text={text}
    direction={direction}
    style={{ ...getMargins({ m, mx, my, mt, mb, mr, ml }), ...style }}
  >
    <i className="fa-regular fa-info-circle" />
  </ToolTip>
);
export default InfoTooltip;
